import type { PageCard } from '@/play/pageTypes'
import { LetterBlocksCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'letter-blocks',
  number: 25,
  title: 'Letter blocks',
  question: 'Does picking up, carrying and dropping a block of voxels under the finger feel immediate?',
  status: 'open',
  accent: '#cfe3f2',
  CardArt: LetterBlocksCardArt,
}
